import { useContext } from 'react';

import { MartyContext } from 'utils/context';
import marketplace from 'cfg/marketplace.json';

// Fallback used for test mocks
const useMartyContext = () => useContext(MartyContext) || { testId: () => {}, marketplace, router: {} };

export default useMartyContext;
